import { IValidator, IValidations, IPriceCategory, IPriceTier } from '@/interfaces';

export class PriceTierValidator implements IValidator<IPriceTier> {
  public isValid(item: IPriceTier) {
    const errors: IValidations<IPriceTier> = {};
    if (item.name.length === 0) errors.name = ['Name is required'];
    if (item.price < 0) errors.price = ['Price cannot be less than 0'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}

export class PriceCategoryValidator implements IValidator<IPriceCategory> {
  public isValid(item: IPriceCategory) {
    const errors: IValidations<IPriceCategory> = {};
    if (item.name.length === 0) errors.name = ['Name is required'];
    if (item.priceTiers === undefined || item.priceTiers.length === 0) errors.priceTiers = ['A Price Tier is Required'];

    const validator = new PriceTierValidator();
    const sessionErrors = item.priceTiers?.map(x => validator.isValid(x)).filter(x => x !== true) ?? [];
    if (sessionErrors.length > 0) errors.priceTiers = ['Price Tiers Have Errors'];

    return Object.keys(errors).length > 0 ? errors : true;
  }
}
